import FullWidthLayout from "@/layouts/FullWidthLayout";
import KCalendar from "kinnect-front/KCalendar/KCalendar";
import { Pageable } from "kinnect-mixins";

export default {
	name: "HomePage",

	metaInfo: { title: "Home" },

	mixins: [ Pageable ],

	render() {
		return <FullWidthLayout>
			<KCalendar></KCalendar>
		</FullWidthLayout>;
	}
};
